import type { PromotionsFeatures } from '../type';

export const promotions: PromotionsFeatures = {
    enabled: false,
    _description: 'Enable/disable promotions as a whole',
    feedbackOptions: {
        enabled: true,
        _description: 'Shows feedback options on promotion close',
    },
    automaticPopup: {
        enabled: false,
        _description:
            'Automatically trigger certain promotions on startup, without the need for user to click on them (eg. info modal)',
    },
    repeatedRefresh: {
        enabled: false,
        _description: 'Enable/disable repeated refresh of promotions during a session',
    },
    promotionService: {
        enabled: false,
        _description: 'Alternative promotion backend service',
    },
    noLux: {
        enabled: false,
        _description: 'Enable/disable event tracking to Lux',
    },
};
